<template>
  <v-row>
    <v-col
      cols="12"
      lg="3"
    >
      <naj-input
        :type-id="formFieldType.selectbox"
        :label="local.lawsuitDetails.court"
        :value="courtId"
        :items="closestCourts"
        :disabled="disabled"
        item-value="id"
        item-text="name"
        :validates="'required'"
        @change="updateCourtId"
      ></naj-input>
      <span
        v-if="caseData.isRelatedToCorona"
        class="user-attention"
      >
        {{ local.lawsuitDetails.coronaAttention }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  inject: ['$validator'],
  props: ['courtId', 'partiesInfo', 'disabled', 'handleGetCourtsInvoker', 'disableLocationSpecializationRule'],
  data() {
    return { closestCourts: [] };
  },
  computed: { ...mapState({ caseData: state => state.lawsuitRequest.case }) },
  watch: {
    handleGetCourtsInvoker(invoker) {
      if (invoker)
        this.handleGetPartiesClosestCourts(invoker);
    },
  },
  mounted() {
    this.handleGetPartiesClosestCourts('mounted');
  },
  methods: {
    ...mapActions(['getPartiesClosestCourts']),
    handleGetPartiesClosestCourts(invoker) {
      const caseTypeId = this.caseData.caseTypeId || null;
      const caseCategoryId = this.caseData.caseCategoryId || null;
      const caseClassificationId = this.caseData.caseClassificationIdNew || null;
      const disableLocationSpecializationRule = this.disableLocationSpecializationRule || null;
      const accidentCityId = this.caseData.cityId || null;
      const isRelatedToCorona = this.caseData.isRelatedToCorona || null;
      if (caseTypeId && caseCategoryId && caseClassificationId && (this.partiesInfo || []).length) {
        const data = {
          invoker,
          caseTypeId,
          caseCategoryId,
          caseClassificationId,
          accidentCityId,
          disableLocationSpecializationRule,
          isRelatedToCorona,
          partiesInfo: this.partiesInfo,
          form: (this.caseData.forms || [])[0],
        };
        this.getPartiesClosestCourts(data)
          .then(({ data }) => {
            this.closestCourts = data.data;
            this.$emit('courtsRetrieved', this.closestCourts);
          });
      }
    },
    updateCourtId(courtId) {
      this.$emit('update:courtId', courtId);
      this.$emit('change', courtId);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-attention {
  font-size: 14px;
  color: red;
  font-weight: bold;
}
</style>
